import { Button } from "@mui/material";
import { ReactNode } from "react";

type ActionButtonVariant = "outlinedPrimary" | "primary" | "dark";

interface ActionButtonProps {
  label: string;
  icon: ReactNode;
  onClick?: () => void;
  variantType: ActionButtonVariant;
}

export function ActionButton({
  label,
  icon,
  onClick,
  variantType,
}: ActionButtonProps) {
  const styles = {
    outlinedPrimary: {
      backgroundColor: "rgba(255, 159, 28, 0.1)",
      color: "#ff9f1c",
      border: "1px solid #ff9f1c",
      "&:hover": {
        backgroundColor: "#ff9f1c",
        color: "#fff",
      },
    },
    primary: {
      backgroundColor: "#ff9f1c",
      color: "#fff",
      boxShadow: "0 8px 20px rgba(255,159,28,0.35)",
      "&:hover": {
        backgroundColor: "#ea580c",
      },
    },
    dark: {
      backgroundColor: "#1f2933",
      color: "#fff",
      "&:hover": {
        backgroundColor: "#111827",
      },
    },
  };

  return (
    <Button
      onClick={onClick}
      startIcon={icon}
      sx={{
        px: 2,
        py: 1.2,
        borderRadius: 2,
        fontWeight: 600,
        fontSize: 14,
        height:50,
        textTransform: "none",
        transition: "all .25s ease",
        ...styles[variantType],
      }}
    >
      {label}
    </Button>
  );
}
